import useFlashMessage from '@core/components/FlashMessage';
import { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';

/**
 *
 */
export const useDisconnectNotify = () => {
  const { addFlashMessage } = useFlashMessage();
  const disconnectsCountRef = useRef(0);
  const { t } = useTranslation();
  const incrementDisconnects = useCallback(
    (closeReason) => {
      disconnectsCountRef.current += 1;
      addFlashMessage(closeReason, 'error');
      if (disconnectsCountRef.current > 1) {
        addFlashMessage(t('clickRecordAndSendIfNetworkIssues'), 'warning');
      }
    },
    [addFlashMessage, t]
  );
  return { incrementDisconnects };
};
